import React from 'react';
import classNames from 'classnames';
import { object, node } from 'prop-types';
import { Icon } from '@fiverr-private/fit';
import { r_times } from '@fiverr-private/fit/icons';

import styles from './index.module.scss';

const SelectTag = ({
    children,
    removeProps
}) => (
    <div className={classNames('flex flex-items-center m-r-8 m-t-4 m-b-4', styles.tag)}>
        <span className="text-semi-bold">{children}</span>
        <button className={classNames('flex flex-items-center flex-justify-end orca-remove-button', styles.button)} {...removeProps}>
            <Icon size={9} color={styles.iconColor}>{r_times}</Icon>
        </button>
    </div>
);

SelectTag.displayName = 'SelectTag';

SelectTag.propTypes = {
    /**
     * What will be displayed inside the Tag, the value of selected Option
     */
    children: node.isRequired,
    /**
     * Bag of event handlers coming from react-select
     */
    removeProps: object
};

export default SelectTag;
